import { PDFComponentProps } from "../types/pdf-types";
import { AccountController } from "@/app/ui/controllers/AccountController";
import {
  ellipsisString,
  formatByCountry,
} from "@/app/infrastructures/misc/Utils";
import { Dispatch } from "@/domain/entities/Dispatch";

const setTextStyle = (doc: any) => {
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);
  doc.setTextColor("#4d4d4d");
};

export const drawLogo = (props: PDFComponentProps, logo: string) => {
  const { doc } = props;
  const pdfWidth = doc.internal.pageSize.width;
  const logoProperties = doc.getImageProperties(logo);
  const logoAspectRatio = logoProperties.height / logoProperties.width;
  const imageWidth = 40;
  const imageHeight = logoAspectRatio * 40;

  doc.addImage(
    logo,
    "PNG",
    pdfWidth - imageWidth - 9,
    10,
    imageWidth,
    imageHeight,
    "logo",
    "FAST",
    0
  );
};

export const drawHeader = (props: PDFComponentProps) => {
  const { doc, translate } = props;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.setTextColor("#4d4d4d");
  doc.text(translate("dispatch.pdfFailed.listTitle"), 8, 15);
  doc.setFillColor("#e0e0e0");
  doc.rect(8, 20, 194, 0.2, "F");
};

const drawCompanyInfo = (props: PDFComponentProps) => {
  const { doc, translate } = props;
  setTextStyle(doc);

  doc.text(translate("dispatch.pdfFailed.consolidatorName"), 10, 29);
  doc.text(":", 36, 29);
  doc.text(
    ellipsisString(
      AccountController.accountData.account_type_detail.company_name,
      25
    ),
    38,
    29
  );

  doc.text(translate("dispatch.pdfFailed.consolidatorCity"), 10, 36);
  doc.text(":", 36, 36);
  doc.text(
    `${AccountController.accountData.account_location.city_code} - ${AccountController.accountData.account_location.city_name}`,
    38,
    36
  );
};

const drawShipmentInfo = (props: PDFComponentProps, dataHead: Dispatch) => {
  const { doc, translate } = props;
  setTextStyle(doc);

  doc.text(translate("dispatch.pdf.totalSttKoli"), 80, 29);
  doc.text(":", 100, 29);
  doc.text(
    `${dataHead.dispatchSttsFailed}/${dataHead.dispatchSttPiecesFailed}`,
    102,
    29
  );
  doc.text(translate("dispatch.pdf.totalBerat"), 80, 36);
  doc.text(":", 100, 36);
  doc.text(
    `${formatByCountry(dataHead.dispatchSttGrossWeightsFailed, { type: 'weight', country: AccountController.accountData.account_type_detail?.countryCode, fractionDigits: 2 })} kg`,
    102,
    36
  );
};

const drawCreatorInfo = (props: PDFComponentProps, dataHead: Dispatch) => {
  const { doc, translate } = props;
  setTextStyle(doc);

  doc.text(translate("dispatch.pdf.createdBy"), 125, 29);
  doc.text(":", 160, 29);
  doc.text(
    `${ellipsisString(dataHead.dispatchCreatedByName, 20)} - ${
      dataHead.dispatchCreatedByRole
    }`,
    162,
    29
  );
};

export const drawInfoColumns = (
  props: PDFComponentProps,
  dataHead: Dispatch
) => {
  drawCompanyInfo(props);
  drawShipmentInfo(props, dataHead);
  drawCreatorInfo(props, dataHead);
};
